module.exports = __webpack_public_path__ + "img/wx_code.c75a9594.jpg";